export default "__VITE_ASSET__148de2a6__"